// =========================================
// お知らせ（ホーム）タブ切り替え
// =========================================

export function initializeNewsTabs() {
  const root = document.querySelector('.m-home-news__inner');
  if (!root) return;

  const tabs = root.querySelectorAll('.m-home-news__tab');
  const panes = root.querySelectorAll('.m-home-news__pane');

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const target = tab.getAttribute('data-tab');

      tabs.forEach((t) => t.classList.remove('m-home-news__tab--active'));
      tab.classList.add('m-home-news__tab--active');

      panes.forEach((pane) => {
        pane.toggleAttribute(
          'hidden',
          pane.getAttribute('data-pane') !== target,
        );
      });
    });
  });
}
